import React from "react"

export default function PillsNav({ children }) {
  return <ul className="nav nav-pills">{children}</ul>
}
